const DISPLAY_TIME_ZONE = "Europe/Madrid";

/**
 * D1 devuelve sus CURRENT_TIMESTAMP como `AAAA-MM-DD HH:MM:SS`, siempre UTC
 * pero sin sufijo de zona. El navegador lo interpretaría como hora local y
 * ocultaría las dos horas de diferencia en verano, así que lo normalizamos.
 */
export function parseApiDate(value: string): Date {
  const trimmed = value.trim();
  const sqliteUtc = trimmed.match(
    /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)$/
  );
  return new Date(sqliteUtc ? `${sqliteUtc[1]}T${sqliteUtc[2]}Z` : trimmed);
}

export function formatFecha(iso: string | undefined | null): string {
  if (!iso) return "—";
  const d = parseApiDate(iso);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("es-ES", {
    timeZone: DISPLAY_TIME_ZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function formatFechaHora(iso: string | undefined | null): string {
  if (!iso) return "—";
  const d = parseApiDate(iso);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString("es-ES", {
    timeZone: DISPLAY_TIME_ZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
